// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

const ASICENTRAL_DOMAIN = process.env.ASICENTRAL_DOMAIN || `dev-asicentral.com`;

export const environment = {
  production: false,
  catalogsEndpoint: `https://api.${ASICENTRAL_DOMAIN}/v1/catalogs`,
};
